;(function () {
  'use strict'

  angular
    .module('contrast.discussion')
    .directive('csStartDiscussionMsg', [csStartDiscussionMsg])

  function csStartDiscussionMsg() {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'views/cs-start-discussion-msg.html',
      controller: 'csStartDiscussionMsgCtrl',
      controllerAs: 'csStartDiscussionMsgCtrl'
    }
  }
})()
